import { diInjectable } from '@di/di';
import { concatUrl } from '@studio/utils/url';
export async function registerFeaturesByFiles(files, origin, brandId) {
    const registerTasks = [];
    __webpack_public_path__ = origin && concatUrl(origin, '/scripts/');
    for (const file of files) {
        if (!file.id.startsWith('preload')) {
            continue;
        }
        const matches = /^([\w-]+)/.exec(file.url);
        switch (matches[1]) {
            case 'widget':
                registerTasks.push(registerWidgetFeature());
                break;
            case 'feed':
                registerTasks.push(registerFeedStoreFeature(brandId));
                break;
            case 'video':
                registerTasks.push(registerVideoFeature());
                break;
        }
    }
    await Promise.all(registerTasks);
    __webpack_public_path__ = '';
}
async function registerFeedStoreFeature(brandId) {
    const { FeedStore: FeedStoreC } = await import(
    /* webpackChunkName: "feed" */ './elements/feed/feed-store');
    diInjectable(6 /* Token.FEED_STORE */, FeedStoreC).withArgs(brandId);
}
async function registerWidgetFeature() {
    const { WidgetRenderer: WidgetRendererC, WidgetAdApi: WidgetAdApiC, CreativeApi: CreativeApiC, TimelineApi: TimelineApiC } = await import(/* webpackChunkName: "widget" */ './elements/widget/widget.module');
    diInjectable(4 /* Token.WIDGET_RENDERER */, WidgetRendererC);
    diInjectable(8 /* Token.WIDGET_AD_API */, WidgetAdApiC);
    diInjectable(9 /* Token.CREATIVE_API */, CreativeApiC);
    diInjectable(10 /* Token.TIMELINE_API */, TimelineApiC);
}
async function registerVideoFeature() {
    const { VideoRenderer: VideoRendererC } = await import(
    /* webpackChunkName: "video" */ './elements/video/video.module');
    diInjectable(7 /* Token.VIDEO_RENDERER */, VideoRendererC);
}
